import { ClassNames } from 'consts/preventScroll';
import { isSSR } from 'utils';

export const preventScroll = (shouldPrevent: boolean): void => {
  if (isSSR) return;

  const { classList, style } = document.body;

  if (shouldPrevent) {
    // Pad by scrollbar width so overflow:hidden does not shift layout.
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : '';
    classList.add(ClassNames.PreventScroll);
  } else {
    classList.remove(ClassNames.PreventScroll);
    style.paddingRight = '';
  }
};
